import React from "react";

function TitleAlertsMobile() {
  return (
    <div className="title-line-alert-mobile">
      <div className="title-block1-mobile-tris">Type</div>
      <div className="title-block1-mobile-bis">Content</div>
      <div className="title-block1-mobile-bis">Date</div>
      {/* <div className="title-block1-mobile">Noted by</div> */}
    </div>
  );
}

export default TitleAlertsMobile;
